import apiService from "../../../../services/service";
import API_ROUTES from "../../../../api-routes";
import { z } from "zod";

export const fetchRequestUsers = async (
  role,
  entityId = "",
  serviceId = "",
) => {
  const { data } = await apiService(API_ROUTES.FETCH_USERS, "GET", {
    replace: {
      page: 1,
      pageSize: 100,
      role,
      searchValue: "",
      entity: entityId,
      service: serviceId,
    },
    schema: z.object({
      page: z.number().optional(),
      pageSize: z.number().optional(),
      role: z.string().optional(),
      search: z.string().optional(),
      entity: z.string().optional(),
      service: z.string().optional(),
    }),
  });
  const users = data?.users || [];
  return { users };
};

export const fetchEntities = async ({
  pageIndex = 0,
  pageSize = 100,
  searchValue = "",
} = {}) => {
  const { data } = await apiService(API_ROUTES.ALL_ENTITIES, "GET", {
    replace: {
      page: pageIndex + 1,
      pageSize,
      searchValue,
    },
    schema: z.object({
      page: z.number().optional(),
      pageSize: z.number().optional(),
      search: z.string().optional(),
    }),
  });
  return { data };
};

export const saveRequest = async (requestData, requestType) => {
  const { data, status } = await apiService(API_ROUTES.ADD_REQUEST, "POST", {
    body: requestData,
    replace: {
      requestType: requestType,
    },
    schema: z.object({
      requestType: z.string(),
    }),
  });
  return { data, status };
};
